import React from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import { MsalProvider } from '@azure/msal-react';
import './App.css';
import RootRoute from './Components/ProtectedRoutes/RootRoute';
import DataExtractionPage from './Pages/DataExtractionPage/DataExtractionPage';
import TaskListPage from './Pages/TaskListPage/TaskListPage';
import NewTaskPage from './Pages/NewTaskPage/NewTaskPage';
import MyFilesPage from './Pages/MyFilesPage/MyFilesPage';
import UserNotificationsPage from './Pages/UserNotificationsPage/UserNotificationsPage';
import ReportsPage from './Pages/ReportsPage/ReportsPage';
import AdminNotificationsPage from './Pages/AdminNotificationsPage/AdminNotificationsPage';
import APIDocumentationPage from './Pages/ApiDocumentationPage/ApiDocumentationPage';
import AdminSupportPage from './Pages/AdminSupportPage/AdminSupportPage';
import MonthlyRequestsPage from './Pages/AdminSupportPage/MonthlyTiicketsPage';
import AdminNewsPage from './Pages/AdminNewsPage/AdminNewsPage';
import GeneralConfigurationsPage from './Pages/AdminConfigurations/GeneralConfigurationTabs';
import AllTicketsPage from './Pages/AdminSupportPage/AllTicketsPage';
import LicenseProtectedRoute from './Components/ProtectedRoutes/LicenseProtectedRoutes';
import LicensePage from './Pages/LicensePage/LicensePage';
import TicketDetailsPage from './Pages/AdminSupportPage/TicketDetailsPage';
import LicensePageNoSeat from './Pages/LicensePageNoSeat/LicensePageNoSeat';
import ChatPage from './Pages/ChatPage/ChatPage';
import ChatFilesPage from './Pages/ChatFilesPage/ChatFilesPage';
import ProductCatalogPage from './Pages/ProductsCatalog/ProductCatalog';
import StoreCatalogPage from './Pages/StoresCatalog/StoreCatalog';
import ProductDetailsPage from './Pages/ProductsCatalog/ProductDetails';
import StoreDetailsPage from './Pages/StoresCatalog/StoreDetails';
import SchedulerTaskListPage from './Pages/SchedulerTaskListPage/SchedulerTaskListPage';
import TemplatesListPage from './Pages/TemplatesPage/TemplatesPage';
import SAPCompanyConfigListPage from './Pages/SAPCompanyConfigPage/SAPCompanyConfigListPage';
import BankConfigPage from './Pages/BankStatementConfigPage/BankConfigPage';
import LogsListPage from './Pages/LogsListPage/LogsListPage';
import NitGlMapPage from './Pages/Conciliation/NitGlMapPage';
import CardRouteMapPage from './Pages/Conciliation/CardRouteMapPage';
import ManualPostingPage from './Pages/Conciliation/ManulaPostingPage';
import UnmatchedInvoicesReportPage from './Pages/Conciliation/UnmatchedInvoicesReportPage';
import MissingInfoReportPage from './Pages/Conciliation/MissingInfoReportPage';
import ConciliationReportsPage from './Pages/Conciliation/ConciliationReportsPage';
import ConciliationExtractionsPage from './Pages/Conciliation/ConciliationExtractionsPage';
import CompaniesPage from './Pages/Management/CompaniesPage';
import FinancialInstitutionsPage from './Pages/Management/FinancialInstitutionsPage';
import FinancialAccountsPage from './Pages/Management/FinancialAccountsPage';
import PaymentCardsPage from './Pages/Management/PaymentCardsPage';
import { SecurityProvider, useSecurity } from './Contexts/SecurityContext';
import PermissionRoute from './Components/ProtectedRoutes/PermissionRoute';
import AccessDeniedPage from './Pages/AccessDeniedPage/AccessDeniedPage';
import UsersAdminPage from './Pages/UsersAdminPage/UsersAdminPage';
import RolesAdminPage from './Pages/RolesAdminPage/RolesAdminPage';
import LicenseManagementPage from './Pages/LicensePage/LicenseManagementPage';
import CompanyAccessPage from './Pages/CompanyAccessPage/CompanyAccessPage';
import { Permissions } from './Security/permissions';
import { getFirstAuthorizedRoute } from './Navigation/navigationConfig';
import { PageLayout2 } from './Components/PageLayout/PageLayout2';

const AuthorizedHome = () => {
    const { hasPermission, companyAccessLoading } = useSecurity();
    if (companyAccessLoading) return null;
    const route = getFirstAuthorizedRoute({ hasPermission });
    return route
        ? <Navigate to={route} replace />
        : <PageLayout2 title="Home"><div className="d-flex flex-grow-1 align-items-center justify-content-center text-center text-muted">
            <div><h4>No applications are available for your account.</h4><p className="mb-0">Contact an administrator if you believe you need access.</p></div>
        </div></PageLayout2>;
};



const Pages = () => {
    return (
        <Routes>
            <Route path='/' element={<RootRoute />} />
            <Route path="/no-seat-assigned" element={<LicensePageNoSeat />} />
            <Route path="/access-denied" element={<AccessDeniedPage />} />

            <Route element={<LicenseProtectedRoute />}>
                {/* <Route exact path="/home" element={<Home />} /> */}
                <Route path="/home" element={<AuthorizedHome />} />

                <Route element={<PermissionRoute permission={Permissions.Extractions.Manual} />}>
                    <Route path="/data-extraction/*" element={<DataExtractionPage />}>
                        <Route path="" element={<TaskListPage />} />
                        <Route path="new-task" element={<NewTaskPage />} />
                    </Route>
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Collaboration.MyDocuments} />}>
                    <Route path='/files' element={<MyFilesPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Collaboration.ChatFiles} />}>
                    <Route path='/chat-files' element={<ChatFilesPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Collaboration.Chat} />}>
                    <Route path='/chat' element={<ChatPage menu="Data" title="Data Chat" />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Collaboration.DocuChat} />}>
                    <Route path='/docu-chat' element={<ChatPage menu="Documents" title="Docu Chat" />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Collaboration.MarcbiChat} />}>
                    <Route path='/marcbi-chat' element={<ChatPage menu="DataFabric" title="MARCBI Chat" />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Collaboration.MarcbiCreative} />}>
                    <Route path='/marcbi-creative' element={<ChatPage menu="FabricCreative" title="MARCBI Creative" />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Collaboration.Notifications} />}>
                    <Route path='/notifications' element={<UserNotificationsPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Collaboration.AdminNotifications} />}>
                    <Route path='/admin-notifications' element={<AdminNotificationsPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Collaboration.News} />}>
                    <Route path='/admin-news' element={<AdminNewsPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Security.Configuration} />}>
                    <Route path='/admin-config' element={<GeneralConfigurationsPage />} />
                </Route>

                <Route element={<PermissionRoute permission={Permissions.Reports.Dashboards} />}>
                    <Route path='/dashboards' element={<ReportsPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Support.Tickets} />}>
                    <Route path='/support' element={<AdminSupportPage />} />
                    <Route path="/support/ticket" element={<TicketDetailsPage />} />
                    <Route path="/support/ticket/:id" element={<TicketDetailsPage />} />
                    <Route path='/support/open-requests' element={<AllTicketsPage />} />
                    <Route path='/support/monthly-requests' element={<MonthlyRequestsPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.DataManagement.ApiConnection} />}>
                    <Route path='/docs/api/v1' element={<APIDocumentationPage />} />
                </Route>

                <Route element={<PermissionRoute permission={Permissions.DataManagement.Products} />}>
                    <Route path='/product-catalog' element={<ProductCatalogPage />} />
                    <Route path='/product-catalog/:id' element={<ProductDetailsPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.DataManagement.Stores} />}>
                    <Route path='/store-catalog' element={<StoreCatalogPage />} />
                    <Route path='/store-catalog/:id' element={<StoreDetailsPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Extractions.ScheduledTasks} />}>
                    <Route path='/scheduled-tasks' element={<SchedulerTaskListPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Extractions.Templates} />}>
                    <Route path='/extraction-templates' element={<TemplatesListPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.DataManagement.SapConnection} />}>
                    <Route path="/sap-company-configs" element={<SAPCompanyConfigListPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.DataManagement.BacConnection} />}>
                    <Route path="/bank-statement-configs" element={<BankConfigPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Management.Companies} />}>
                    <Route path="/management/companies" element={<CompaniesPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Management.FinancialInstitutions} />}>
                    <Route path="/management/financial-institutions" element={<FinancialInstitutionsPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Management.FinancialAccounts} />}>
                    <Route path="/management/financial-accounts" element={<FinancialAccountsPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Management.PaymentCards} />}>
                    <Route path="/management/payment-cards" element={<PaymentCardsPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Extractions.ExecutionLogs} />}>
                    <Route path="/execution-logs" element={<LogsListPage />} />
                </Route>

                <Route element={<PermissionRoute permission={Permissions.Conciliation.NitGlMapping} />}>
                    <Route path="/nit-gl-mapping" element={<NitGlMapPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Conciliation.AccountMapping} />}>
                    <Route path="/card-center-route-mapping" element={<CardRouteMapPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Conciliation.ManualPosting} />}>
                    <Route path="/manual-posting" element={<ManualPostingPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Conciliation.Extractions} />}>
                    <Route path="/conciliation/extractions" element={<ConciliationExtractionsPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Concur.Expenses} />}>
                    <Route path="/concur-expenses" element={<ConciliationExtractionsPage concurOnly />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Conciliation.Reports} />}>
                    <Route path="/unmatched-invoices" element={<UnmatchedInvoicesReportPage />} />
                    <Route path="/missing-info" element={<MissingInfoReportPage />} />
                    <Route path="/conciliation/reports" element={<ConciliationReportsPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Security.Users} />}>
                    <Route path="/admin/users" element={<UsersAdminPage />} />
                    <Route path="/security" element={<Navigate to="/admin/users" replace />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Security.Roles} />}>
                    <Route path="/admin/roles" element={<RolesAdminPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Security.CompanyAccess} />}>
                    <Route path="/admin/company-access" element={<CompanyAccessPage />} />
                </Route>
                <Route element={<PermissionRoute permission={Permissions.Security.Licenses} />}>
                    <Route path="/admin/licenses" element={<LicenseManagementPage />} />
                    <Route path="/license" element={<LicensePage />} />
                </Route>
            </Route>
        </Routes>
    );
};

const App = ({ instance }) => {
    return (
        <MsalProvider instance={instance}>
            <SecurityProvider>
                <Pages />
            </SecurityProvider>
        </MsalProvider>
    );
};

export default App;
